import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { auth } from '../services/api';
import { useStore } from '../store';
import { useTheme, useAppStyles } from '../theme';

export default function RegisterScreen() {
  const C = useTheme();
  const styles = useAppStyles();
  const nav = useNavigate();
  const { login } = useStore();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ full_name: '', email: '', phone: '', password: '', confirmPassword: '' });
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const set = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const sendOtp = async () => {
    if (!form.full_name.trim()) return toast.error('Enter your full name');
    if (!form.email.trim()) return toast.error('Enter your email');
    if (!form.password || form.password.length < 6) return toast.error('Password must be 6+ characters');
    if (form.password !== form.confirmPassword) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await auth.sendOtp(form.email);
      toast.success('OTP sent to ' + form.email);
      setStep(2);
    } catch (e) { toast.error(e.message); }
    setLoading(false);
  };

  const register = async () => {
    if (otp.length < 4) return toast.error('Enter the OTP from your email');
    setLoading(true);
    try {
      const r = await auth.register({
        email: form.email,
        password: form.password,
        full_name: form.full_name,
        phone: form.phone,
        otp,
        username: form.email.split('@')[0],
      });
      const token = r.token || r.access_token;
      const user  = r.user  || { email: form.email, full_name: form.full_name };
      login(user, token);
      toast.success('Account created!');
      nav('/onboarding');
    } catch (e) { toast.error(e.message || 'Registration failed'); }
    setLoading(false);
  };

  const inp = {
    width: '100%', background: C.bg, border: '1px solid #2a2a4a',
    borderRadius: 12, padding: '14px 16px', color: '#fff',
    fontSize: 15, outline: 'none', boxSizing: 'border-box',
  };

  const focusStyle = e => e.target.style.borderColor = '#6366f1';
  const blurStyle  = e => e.target.style.borderColor = C.inputBorder;

  return (
    <div style={{
      
      background: C.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Logo */}
        <div style={{textAlign:'center',marginBottom:24}}>
          <img src="/vgo-logo.png" alt="VGO" style={{width:72,height:72,objectFit:'contain',marginBottom:12,filter:'drop-shadow(0 4px 16px #6366f155)'}} />
          <div style={{ fontSize: 26, fontWeight: 800, color: '#fff' }}>
            {step === 1 ? 'Create Account' : 'Verify Email'}
          </div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 4 }}>
            {step === 1 ? 'Join the VGO ecosystem' : `Code sent to ${form.email}`}
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: C.card, border: '1px solid #1e1e3a',
          borderRadius: 24, padding: '28px 24px',
          boxShadow: '0 24px 64px rgba(0,0,0,0.5)'
        }}>
          {/* Progress bar */}
          <div style={{ display: 'flex', gap: 6, marginBottom: 24 }}>
            {[1, 2].map(i => (
              <div key={i} style={{
                flex: 1, height: 3, borderRadius: 3,
                background: step >= i ? '#6366f1' : C.border,
                transition: 'background 0.3s'
              }} />
            ))}
          </div>

          {step === 1 ? (
            <>
              {[
                { key: 'full_name', label: 'FULL NAME', placeholder: 'Your full name', type: 'text' },
                { key: 'email',     label: 'EMAIL',     placeholder: 'you@example.com', type: 'email' },
                { key: 'phone',     label: 'PHONE (optional)', placeholder: '+91 9999999999', type: 'tel' },
                { key: 'password',  label: 'PASSWORD',  placeholder: '••••••••', type: 'password' },
                { key: 'confirmPassword', label: 'CONFIRM PASSWORD', placeholder: '••••••••', type: 'password' },
              ].map(({ key, label, placeholder, type }) => (
                <div key={key} style={{ marginBottom: 14 }}>
                  <label style={{ fontSize: 11, color: C.muted, display: 'block', marginBottom: 7, fontWeight: 600, letterSpacing: 0.5 }}>{label}</label>
                  <input
                    type={type} placeholder={placeholder}
                    value={form[key]} onChange={set(key)}
                    onFocus={focusStyle} onBlur={blurStyle}
                    style={inp}
                  />
                </div>
              ))}

              <button onClick={sendOtp} disabled={loading} style={{
                width: '100%', padding: '15px', marginTop: 6,
                background: loading ? C.border : 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                border: 'none', borderRadius: 14, color: '#fff',
                fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
                boxShadow: loading ? 'none' : '0 4px 20px #6366f133'
              }}>{loading ? 'Sending OTP...' : 'Continue →'}</button>

              <div style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: C.muted }}>
                Have an account?{' '}
                <span onClick={() => nav('/login')} style={{ color: '#6366f1', cursor: 'pointer', fontWeight: 600 }}>Sign in</span>
              </div>
            </>
          ) : (
            <>
              {/* OTP display */}
              <div style={{
                background: '#6366f111', border: '1px solid #6366f133',
                borderRadius: 14, padding: '14px 16px', marginBottom: 20, textAlign: 'center'
              }}>
                <div style={{ fontSize: 12, color: C.muted, marginBottom: 4 }}>Check your email inbox</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>{form.email}</div>
              </div>

              <label style={{ fontSize: 11, color: C.muted, display: 'block', marginBottom: 8, fontWeight: 600, letterSpacing: 0.5 }}>ENTER OTP</label>
              <input
                aria-label="0 0 0 0 0 0" placeholder="0 0 0 0 0 0"
                value={otp}
                onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                onKeyDown={e => e.key === 'Enter' && register()}
                onFocus={focusStyle} onBlur={blurStyle}
                style={{ ...inp, fontSize: 28, fontWeight: 800, letterSpacing: 14, textAlign: 'center', marginBottom: 20 }}
                autoFocus
              />

              <button onClick={register} disabled={loading} style={{
                width: '100%', padding: '15px',
                background: loading ? C.border : 'linear-gradient(135deg, #10b981, #059669)',
                border: 'none', borderRadius: 14, color: '#fff',
                fontSize: 16, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
                boxShadow: loading ? 'none' : '0 4px 20px #10b98133', marginBottom: 12
              }}>{loading ? 'Creating account...' : '✓ Verify & Create Account'}</button>

              <button onClick={sendOtp} disabled={loading} style={{
                width: '100%', padding: '12px', background: 'none',
                border: '1px solid #1e1e3a', borderRadius: 14, color: C.muted,
                fontSize: 14, cursor: 'pointer'
              }}>Resend OTP</button>

              <button onClick={() => setStep(1)} style={{
                width: '100%', padding: '10px', background: 'none',
                border: 'none', color: '#444', fontSize: 13, cursor: 'pointer', marginTop: 4
              }}>← Change details</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
